import { ApiClient } from "../api.client";
import {
  GetUnhandledFeedbacksRequest,
  GetUnhandledFeedbacksResponse,
} from "./types";

const FeedbacksApi = {
  getUnhandledFeedbacks(params: GetUnhandledFeedbacksRequest) {
    return ApiClient.get<GetUnhandledFeedbacksResponse>("/admin/feedbacks", {
      params,
    });
  },
};

export { FeedbacksApi };
